import { Control, Controller } from "react-hook-form";
import { AgentDatabaseEntry, DatabasesField } from "../DatabasesField";

export const DatabasesFieldNCL = ({
  name,
  control,
  isDisabled,
  defaultValue,
}: {
  name: string;
  control: Control<Record<string, unknown>>;
  isDisabled?: boolean;
  defaultValue?: unknown;
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => (
        <DatabasesField
          databases={field.value as AgentDatabaseEntry[] | undefined}
          onDatabasesChange={field.onChange}
          isDisabled={isDisabled}
        />
      )}
    />
  );
};
